/**
 * API composable para obtener configuración general de la aplicación
 */

import { useApiResource } from '~/composables/api/useApiResource'

export const useConfigApi = () => {
  const { loading, error, customEndpoint } = useApiResource('configs', {
    deserialize: true,
    methods: {
      list: false,
      getById: false,
      create: false,
      update: false,
      delete: false
    }
  })

  /**
   * GET /configs
   * Obtiene la configuración general de la aplicación
   * Incluye URLs de buckets S3 y otras configuraciones públicas
   * @returns {Promise} - Response con configuración general
   */
  const getConfig = customEndpoint(() => ({
    url: '/configs',
    method: 'GET',
    deserialize: true
  }))

  return {
    loading,
    error,
    getConfig
  }
}
